import dayjs from 'dayjs';

// Intelligently parses date strings including natural language expressions (today, tomorrow, next friday)
// and dates without years, automatically inferring the intended year based on context
export const parseSmartDate = (dateString: string) => {
  const currentDate = dayjs();
  const currentYear = currentDate.year();
  const lowerDateString = dateString.toLowerCase().trim();

  // Handle common date expressions
  switch (lowerDateString) {
    case 'today':
      return currentDate.format('MM/DD/YYYY');
    case 'tomorrow':
      return currentDate.add(1, 'day').format('MM/DD/YYYY');
    case 'yesterday':
      return currentDate.subtract(1, 'day').format('MM/DD/YYYY');
    case 'next week':
      return currentDate.add(1, 'week').format('MM/DD/YYYY');
    case 'last week':
      return currentDate.subtract(1, 'week').format('MM/DD/YYYY');
    case 'next month':
      return currentDate.add(1, 'month').format('MM/DD/YYYY');
    case 'last month':
      return currentDate.subtract(1, 'month').format('MM/DD/YYYY');
  }

  // Handle expressions with "next" and days of the week
  if (lowerDateString.startsWith('next ')) {
    const dayOfWeek = lowerDateString.substring(5); // Remove "next "
    const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayIndex = daysOfWeek.indexOf(dayOfWeek);

    if (dayIndex !== -1) {
      // Find the next occurrence of this day of the week
      const currentDayOfWeek = currentDate.day();
      const daysToAdd = (dayIndex + 7 - currentDayOfWeek) % 7 || 7; // if today, go to next week
      return currentDate.add(daysToAdd, 'day').format('MM/DD/YYYY');
    }
  }

  const parsedDate = dayjs(dateString);

  if (parsedDate.isValid() && parsedDate.year() <= 2001) {
    // Add current year if date is without year like "May 27 or 12/10"
    const withCurrentYear = parsedDate.year(currentYear);

    // Add next year if the resulting date is in the past by more than a 6 months
    if (withCurrentYear.isBefore(currentDate.subtract(6, 'month'))) {
      return withCurrentYear.year(currentYear + 1).format('MM/DD/YYYY');
    }

    return withCurrentYear.format('MM/DD/YYYY');
  }

  return parsedDate.isValid() ? parsedDate.format('MM/DD/YYYY') : dateString;
};
